import {
  GridRenderCellParams,
  GridValidRowModel,
  GridTreeNodeWithRender,
} from "@mui/x-data-grid-premium";
import { ButtonDS, CheckOutlined, InputDS, Spacer } from "@qivia/ui";
import { useCallback, useState } from "react";
import { connectDevicesToProviderAsync } from "../telemetrySlice";
import { useAppDispatch } from "../../../redux/hooks";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useParams } from "react-router-dom";

export const UpdateDeviceIdCell = (props: {
  cellProps: GridRenderCellParams<
    GridValidRowModel,
    unknown,
    unknown,
    GridTreeNodeWithRender
  >;
}) => {
  const { t } = useTranslation();
  const { cellProps } = props;
  const dispatch = useAppDispatch();
  const [deviceId, setDeviceId] = useState<string>(
    (cellProps.value as string) || "",
  );
  const params = useParams();

  const handleSubmit = useCallback(() => {
    void dispatch(
      connectDevicesToProviderAsync({
        data: [
          {
            companyUuid: params.id as string,
            vehicleUuid: cellProps.row["uuid"] as string,
            departmentUuid: cellProps.row["department"] as string | null,
            vin: cellProps.row["vin"] as string,
            brand: cellProps.row["brand"] as string,
            registrationNumber: cellProps.row["registrationNumber"] as string,
            deviceId: deviceId,
          },
        ],
      }),
    );
  }, [dispatch, deviceId, cellProps.row, params.id]);

  return (
    <StyledDeviceIdContainer>
      <InputDS
        placeholder={t(
          "telemetry.addDevicesToProvider.input.deviceId.placeholder",
        )}
        onChange={(e) => setDeviceId(e.target.value)}
        withoutSpacerBottom
      />
      <Spacer x={1} />
      <ButtonDS
        singleIcon={{ icon: <CheckOutlined />, size: "S" }}
        format="fill"
        buttonType="primary"
        onClick={handleSubmit}
      />
    </StyledDeviceIdContainer>
  );
};

const StyledDeviceIdContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;
